import React, { useMemo } from "react";

const Branding = ({ width = 148, height = 40 }) => {
  const svgContent = useMemo(() => {
    return (
      <svg
        id="Group_30222"
        data-name="Group 30222"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 148.011 40.601"
      >
        <path
          id="Path_17600"
          data-name="Path 17600"
          d="M10.175-6.006,8.239-11.3q-.143-.352-.3-.836t-.308-1.045q-.143.561-.3,1.05t-.3.852L5.115-6.006ZM15.4,0H13.112a.977.977,0,0,1-.627-.192,1.2,1.2,0,0,1-.363-.479L10.934-3.916H4.345L3.157-.671a1.055,1.055,0,0,1-.341.462A.952.952,0,0,1,2.189,0H-.121L6.138-15.906H9.152ZM34.3-15.906V0H31.691V-10.274q0-.616.066-1.331L26.95-2.574a1.111,1.111,0,0,1-1.045.649h-.418a1.111,1.111,0,0,1-1.045-.649L19.58-11.638q.033.363.055.715t.022.649V0H17.05V-15.906h2.233q.2,0,.341.011a.922.922,0,0,1,.258.055.562.562,0,0,1,.209.143,1.222,1.222,0,0,1,.181.264L25.036-6.6q.187.352.347.726t.313.77q.154-.407.319-.787t.352-.732l4.7-8.811a1.11,1.11,0,0,1,.187-.264.611.611,0,0,1,.215-.143.922.922,0,0,1,.259-.055q.143-.011.341-.011ZM47.157-2.442V0H37.84V-15.906H40.8V-2.442ZM50.732.033a1.442,1.442,0,0,1-.6.759,1.592,1.592,0,0,1-.841.253H48.136L54.56-15.389A1.458,1.458,0,0,1,55.1-16.1a1.467,1.467,0,0,1,.847-.248h1.166ZM70.158-3.751a.59.59,0,0,1,.429.187L71.753-2.3A6.4,6.4,0,0,1,69.372-.462a8.207,8.207,0,0,1-3.394.638,8.019,8.019,0,0,1-3.185-.605,7.019,7.019,0,0,1-2.415-1.683,7.368,7.368,0,0,1-1.535-2.574,9.662,9.662,0,0,1-.534-3.267,9.094,9.094,0,0,1,.572-3.283,7.547,7.547,0,0,1,1.611-2.569,7.293,7.293,0,0,1,2.481-1.677,8.227,8.227,0,0,1,3.19-.6,7.835,7.835,0,0,1,3.086.572,7.351,7.351,0,0,1,2.293,1.5l-.99,1.375a.9.9,0,0,1-.226.231.639.639,0,0,1-.379.1.726.726,0,0,1-.341-.093q-.176-.093-.385-.231t-.484-.3a3.984,3.984,0,0,0-.638-.3,5.207,5.207,0,0,0-.841-.231,5.814,5.814,0,0,0-1.105-.094,4.906,4.906,0,0,0-1.952.38,4.243,4.243,0,0,0-1.523,1.1,5.071,5.071,0,0,0-.99,1.76,7.376,7.376,0,0,0-.352,2.371,6.968,6.968,0,0,0,.379,2.387,5.248,5.248,0,0,0,1.028,1.76,4.392,4.392,0,0,0,1.529,1.095,4.726,4.726,0,0,0,1.892.379A8.242,8.242,0,0,0,67.259-2.4a4.646,4.646,0,0,0,.9-.209,4,4,0,0,0,.781-.368,4.88,4.88,0,0,0,.731-.556,1.043,1.043,0,0,1,.231-.159A.559.559,0,0,1,70.158-3.751Zm6.6-9.8v4.708H82.72v2.365H76.758V0h-2.97V-15.906H83.82v2.354Zm20.592.077h-4.8V0H89.595V-13.475H84.8v-2.431H97.35Z"
          transform="translate(50.661 25.643)"
          fill="#fff"
        />
        <g id="Group_29638" data-name="Group 29638" transform="translate(0 0)">
          <path
            id="Path_17530"
            data-name="Path 17530"
            d="M46.168,19.868V12H15.01v7.868"
            transform="translate(-15.005 -12)"
            fill="#0ad172"
          />
          <path
            id="Path_17531"
            data-name="Path 17531"
            d="M15.009,37.493h7.868V12H15.009"
            transform="translate(-15.004 -12)"
            fill="#0ad172"
          />
          <path
            id="Path_17534"
            data-name="Path 17534"
            d="M71.463,26.551V48.419l7.786-5.665v-8.5Z"
            transform="translate(-40.3 -18.52)"
            fill="#25f290"
          />
          <path
            id="Path_17532"
            data-name="Path 17532"
            d="M33.732,68.954,15,54,20.506,48.5,33.788,59.04Z"
            transform="translate(-15 -28.353)"
            fill="#0ad172"
          />
          <path
            id="Path_17533"
            data-name="Path 17533"
            d="M47.946,68.954,66.678,54,61.172,48.5,47.889,59.04Z"
            transform="translate(-29.738 -28.353)"
            fill="#25f290"
          />
        </g>
      </svg>
    );
  }, [width, height]);

  return svgContent;
};

export default Branding;



// WEBPACK FOOTER //
// ./src/assets/Branding.jsx